<template>
  <NConfigProvider
    :locale="zhCN"
    :theme="getDarkTheme"
    :theme-overrides="getThemeOverrides"
    :date-locale="dateZhCN"
  >
    <NMessageProvider>
      <NMessageContent />
      <NNotificationProvider>
        <NNotificationContent />
        <NDialogProvider>
          <NDialogContent />
          <NModalProvider>
            <ModalContent />
            <NLoadingBarProvider>
              <NLoadingBarContent />
              <slot />
            </NLoadingBarProvider>
          </NModalProvider>
        </NDialogProvider>
      </NNotificationProvider>
    </NMessageProvider>
  </NConfigProvider>
</template>

<script setup lang="ts">
import useThemeStore from '@/stores/themeStore'
import { lighten } from '@/utils'
import {
  dateZhCN,
  NConfigProvider,
  NDialogProvider,
  NLoadingBarProvider,
  NMessageProvider,
  NModalProvider,
  NNotificationProvider,
  zhCN,
  darkTheme,
} from 'naive-ui'
import { computed } from 'vue'
import NDialogContent from './DialogContent'
import NLoadingBarContent from './LoadingBarContent'
import NMessageContent from './MessageContent'
import ModalContent from './ModalContent'
import NNotificationContent from './NotificationContent'
defineOptions({
  name: 'AppProvider',
})

const themeStore = useThemeStore()

const getDarkTheme = computed(() => (themeStore.useDarkTmeme ? darkTheme : undefined))

const getThemeOverrides = computed(() => {
  const appTheme = themeStore.appTheme
  const lightenStr = lighten(themeStore.appTheme, 6)
  return {
    common: {
      primaryColor: appTheme,
      primaryColorHover: lightenStr,
      primaryColorPressed: lightenStr,
    },
    LoadingBar: {
      colorLoading: appTheme,
    },
  }
})
</script>

<style scoped>
:global(.n-dropdown-menu) {
  border: 1px solid #222;
}
</style>
